import { render } from "./ThreadIntelligenceWidget.vue?vue&type=template&id=7b2818d4"
import script from "./ThreadIntelligenceWidget.vue?vue&type=script&lang=js"
export * from "./ThreadIntelligenceWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__